export const cleanEmptyFields = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(v => cleanEmptyFields(v));
  }
  
  if (obj !== null && typeof obj === 'object') {
    const newObj = { ...obj }; 
    
    Object.keys(newObj).forEach(key => {
      let value = newObj[key];
      
      if (typeof value === 'object' && value !== null) {
        value = cleanEmptyFields(value);
        newObj[key] = value; 
      }

      const isEmptyString = typeof value === 'string' && value.trim() === '';
      const isNullOrUndefined = value === null || value === undefined;

      if (isEmptyString || isNullOrUndefined) {
        delete newObj[key];
      } 
    });
    
    return newObj;
  }
    return obj;
};